import { SlideObject } from '../types';
import { MOVE_THRESHOLD_PX } from './dragSession';
import { expandGroupSelection } from './objectGroup';

export type MarqueeRect = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export function slidePointFromClient(
  clientX: number,
  clientY: number,
  surface: { left: number; top: number },
  scale: number,
): { x: number; y: number } {
  const safeScale = scale || 1;
  return {
    x: (clientX - surface.left) / safeScale,
    y: (clientY - surface.top) / safeScale,
  };
}

export function normalizeRect(x0: number, y0: number, x1: number, y1: number): MarqueeRect {
  return {
    x: Math.min(x0, x1),
    y: Math.min(y0, y1),
    w: Math.abs(x1 - x0),
    h: Math.abs(y1 - y0),
  };
}

export function isMarqueeGesture(dx: number, dy: number, threshold = MOVE_THRESHOLD_PX): boolean {
  return Math.hypot(dx, dy) > threshold;
}

export function rectsIntersect(a: MarqueeRect, b: MarqueeRect): boolean {
  return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

export function objectBounds(object: Pick<SlideObject, 'x' | 'y' | 'w' | 'h'>): MarqueeRect {
  return { x: object.x, y: object.y, w: object.w, h: object.h };
}

export function objectsIntersectingRect(objects: SlideObject[], rect: MarqueeRect): SlideObject[] {
  return objects.filter((object) => rectsIntersect(objectBounds(object), rect));
}

export function nextMarqueeSelection(
  objects: SlideObject[],
  currentIds: string[],
  hitIds: string[],
  options?: { additive?: boolean },
): string[] {
  const expanded = expandGroupSelection(objects, hitIds);
  if (!options?.additive) return expanded;
  const merged = new Set([...currentIds, ...expanded]);
  return objects.filter((object) => merged.has(object.id)).map((object) => object.id);
}
